// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePage_root__12oK-","welcome":"HomePage_welcome__2ziN1","info":"HomePage_info__L6q8_","title":"HomePage_title__2SwkK","subtitle":"HomePage_subtitle__T007j"};